import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem } from '@blueprintjs/core';
import { useState } from 'react';
function isAccessLabelByKey(options) {
    return 'itemTextKey' in options;
}
function getLabel(item, options) {
    const isAccessLByLabelKey = isAccessLabelByKey(options);
    if (!item || (isAccessLByLabelKey && !options.itemTextKey)) {
        return null;
    }
    if (isAccessLByLabelKey) {
        return item[options.itemTextKey];
    }
    return options.getItemText(item);
}
export function useSelect(options) {
    const { defaultSelectedItem = null } = options;
    const [value, setValue] = useState(defaultSelectedItem);
    const itemRenderer = getItemRenderer(value, options);
    const onItemSelect = setValue;
    const popoverProps = {
        onOpened: (node) => {
            const firstUl = node.querySelector('ul');
            if (firstUl) {
                firstUl.tabIndex = 0;
                firstUl.focus();
            }
        },
    };
    const popoverTargetProps = {
        style: { display: 'inline-block' },
    };
    const itemPredicate = (query, item) => {
        const label = getLabel(item, options);
        if (!label)
            return false;
        return label.toLowerCase().includes(query.toLowerCase());
    };
    const itemListPredicate = (query, items) => {
        return items.filter((item) => {
            const label = getLabel(item, options);
            if (!label)
                return false;
            return label.toLowerCase().includes(query.toLowerCase());
        });
    };
    return {
        value,
        setValue,
        itemRenderer,
        onItemSelect,
        popoverProps,
        popoverTargetProps,
        itemPredicate,
        itemListPredicate,
    };
}
function getItemRenderer(value, options) {
    const selectedLabel = getLabel(value, options);
    const render = (item, { handleClick, handleFocus, modifiers, index }) => {
        const label = getLabel(item, options);
        return (_jsx(MenuItem, { active: modifiers.active, disabled: modifiers.disabled, selected: selectedLabel === label, onClick: handleClick, onFocus: handleFocus, roleStructure: "listoption", text: label }, index));
    };
    return render;
}
//# sourceMappingURL=useSelect.js.map